import { createTemplatesZodObject } from "@@/shared/alfred/ai/tools/create-template";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { storageItemImageZodSchema } from "@@/shared/storage-items/storage-item-images/storage-item-image";
import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";
import { z } from "zod";

type PromptMessageId = Branded<string, "PromptMessageId">;
const {
    zodSchema: PromptMessageIdZodSchema,
    factory: promptMessageIdFactory,
    assert: isPromptMessageId,
} = genericId<PromptMessageId>("prompt_mes__", {
    regexMatch: /(^prompt_mes_.*$)/,
});

const _promptMessagesZodObject = z.object({
    _id: PromptMessageIdZodSchema,
    _type: z.literal("PROMPT_MESSAGE"),
    _createdAt: isoAndUnixZodSchema,
    _finishedAt: isoAndUnixZodSchema.optional(),

    role: z.enum(["user", "system", "assistant"]),
    text: z.string(),
    images: storageItemImageZodSchema.array().optional(),

    status: z.enum(["PENDING", "FINISHED", "FAILED"]),

    runId: z.string().optional(),
    messageId: z.string().optional(),

    __OPENAI: z.any().optional(),

    parsedData: createTemplatesZodObject.optional(),
});

type PromptMessage = z.infer<typeof _promptMessagesZodObject>;

type FactoryParams = Omit<PromptMessage, "_id" | "_type">;
const promptMessageFactory = (params: FactoryParams): PromptMessage => {
    return {
        ...params,
        _id: promptMessageIdFactory(),
        _type: "PROMPT_MESSAGE",
        _createdAt: params._createdAt ?? nowIsoAndUnix(),
    };
};

export {
    isPromptMessageId,
    promptMessageFactory,
    promptMessageIdFactory,
    PromptMessageIdZodSchema,
};
export type { PromptMessage };
